import React from 'react';

const FacebookIcon = () => (
  <svg viewBox="0 0 36 36">
    <path d="M18.964 25.572v-6.937h2.043l.27-2.39h-2.313l.004-1.197c0-.623.063-.957 1.018-.957h1.277V11.7H19.22c-2.454 0-3.317 1.16-3.317 3.11v1.435h-1.53v2.39h1.53v6.937h3.061z" />
  </svg>
);

export default FacebookIcon;
